module.exports = __webpack_public_path__ + "media/images/front/clinicwiki/arrow-down-581fbf599eb1fafdc2fc6f86845395e9.png";